import { render, staticRenderFns } from "./FieldQualidade.vue?vue&type=template&id=47621f86"
import script from "./FieldQualidade.vue?vue&type=script&lang=js"
export * from "./FieldQualidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports